import React from 'react';
import { Col } from './Col';
import { Container } from './Container';
import { Row } from './Row';
/**
 * @param children - ReactNode
 * @return ReactElement
 */
export function GridWrapper({ children, containerProps, colProps, rowProps, className, id, }) {
    return (React.createElement(Container, { ...containerProps, id: id, className: className },
        React.createElement(Row, { ...rowProps },
            React.createElement(Col, { ...colProps }, children))));
}
Container.displayName = 'Container_Component';
